import React , { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import Comments from '../../components/Comments/comments';
import VideoHorizontal from '../../components/Videohorizontal/videohorizontal';
import VideoMetaData from '../../components/videoMetaData/videoMetaData';
import { getVideoById , getRelatedVideos} from '../../redux/actions/videos.action';
import "./_watchScreen.scss"
import Header from '../../components/header/Header';
import Videoplayersidebar from '../../components/videoplayersidebar/Videoplayersidebar';


function WatchScreen() {

    const {id} = useParams();

    const dispatch = useDispatch()

        useEffect(() => {
            dispatch(getVideoById(id))
            dispatch(getRelatedVideos(id))
        }, [dispatch, id])

    const { video, loading } = useSelector(state => state.selectedVideo)

    const { videos, loading: relatedVideosLoading } = useSelector(
        state => state.relatedVideos
     )

    return (
        <>
        <div>
            <Header />
            <Videoplayersidebar />
            <div className="videoplayer">
            <Row>
            <Col lg={8}>
            <div className='watchScreen__player'>
               <iframe
                  src={`https://www.youtube.com/embed/${id}`}
                  frameBorder='0'
                  title={video?.snippet?.title}
                  allowFullScreen
                  width='100%'
                  height='100%'></iframe>
            </div>

            {!loading ? (
               <VideoMetaData video={video} videoId={id} />
            ) : (
               <h6>Loading...</h6>
            )}

            <Comments videoId={id} />
            </Col>
            <Col lg={4}>
            {!loading ? (
               videos
                  ?.filter(video => video.snippet)
                  .map(video => (
                     <VideoHorizontal video={video} key={video.id.videoId} />
                  ))
            ) : (
               <SkeletonTheme color='#343a40' highlightColor='#3c4147'>
                  <Skeleton width='100%' height='130px' count={15} />
               </SkeletonTheme>
            )}
          
            </Col>
            </Row>
            </div>
        </div>
        </>
    )
}

export default WatchScreen;
